<template>
  <div :class="`${prefixCls}`">
    <div
      v-for="(file, i) in files"
      :key="i"
      :class="$_fileClasses(file)"
    >
      <div :class="prefixCls+'__info'" @click="$_onPreviewClick(file)">
        <t-icon v-if="file.status !== 'finished'" icon="loading"></t-icon>
        <t-icon :icon="$_iconByExt(file)"></t-icon>
        <a :href="file.url" :class="prefixCls+'__name'" target="_blank">{{ file.name }}</a>
        <t-icon
          v-show="file.status === 'finished'"
          title="Remove file"
          icon="close"
          @click.native.stop="$_onRemoveClick(file)"
        ></t-icon>
      </div>
      <transition v-if="file.status === 'uploading'" name="fade">
        <t-progress :percent="file.percentage" hide-info size="sm" :class="prefixCls+'__progress'"></t-progress>
      </transition>
    </div>
  </div>
</template>

<script>
import TIcon from '../icon'
import TProgress from '../progress'
import { PREFIX_CLASS } from '@/utils/constants'

const PREFIX_CLS = `${PREFIX_CLASS}upload-list`

export default {
  name: 'TUploadList',
  components: {
    TProgress,
    TIcon
  },
  props: {
    files: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      prefixCls: PREFIX_CLS
    }
  },
  methods: {
    $_fileClasses(file) {
      return [
        `${PREFIX_CLS}__item`,
        {
          [`${PREFIX_CLS}__item--done`]: file.status === 'finished'
        }
      ]
    },
    $_iconByExt(file) {
      const ext =
        file.name
          .split('.')
          .pop()
          .toLocaleLowerCase() || ''
      let icon = 'attachment-outline'
      if (['gif', 'jpg', 'jpeg', 'png', 'bmp', 'webp'].indexOf(ext) > -1) {
        icon = 'image-outline'
      }
      if (
        ['mp4', 'm3u8', 'rmvb', 'avi', 'swf', '3gp', 'mkv', 'flv'].indexOf(
          ext
        ) > -1
      ) {
        icon = 'attachment-outline'
      }
      if (['mp3', 'wav', 'wma', 'ogg', 'aac', 'flac'].indexOf(ext) > -1) {
        icon = 'attachment-outline'
      }
      if (['doc', 'txt', 'docx', 'pages', 'epub', 'pdf'].indexOf(ext) > -1) {
        icon = 'attachment-outline'
      }
      if (['numbers', 'csv', 'xls', 'xlsx'].indexOf(ext) > -1) {
        icon = 'attachment-outline'
      }
      if (['keynote', 'ppt', 'pptx'].indexOf(ext) > -1) {
        icon = 'attachment-outline'
      }
      return icon
    },
    $_onPreviewClick(file) {
      this.$emit('preview-file', file)
    },
    $_onRemoveClick(file) {
      this.$emit('remove-file', file)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/upload/upload-list.vue